import * as React from "react";
import "../../../gatsby-browser";
import statisticsData from "../../data/statistics.json";

class CEOMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ceoData: statisticsData.ceoMessage,
    };
  }

  render() {
    const { ceoData } = this.state;

    return (
      <>
        <section id="ceo-message" className="wow fadeIn" style={{ padding: "60px 0", backgroundColor: "#f8f9fa" }}>
          <div className="container">
            <div className="row about-extra">
              <div className="col-lg-4 col-md-12 wow fadeInUp" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div
                  style={{
                    width: "250px",
                    height: "250px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "5px solid #1d89e4",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                  }}
                >
                  <img
                    src={ceoData.image}
                    alt={ceoData.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.src = "/teamImage/dummy.jpg";
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-8 col-md-12 wow fadeInUp pt-5 pt-lg-0">
                <h2
                  className="light-text"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1.5rem",
                    color: "#1d89e4",
                  }}
                >
                  MESSAGE FROM THE CEO
                </h2>
                <div
                  style={{
                    backgroundColor: "#ecf5ff",
                    padding: "2rem",
                    borderRadius: "10px",
                    marginBottom: "1.5rem",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.8",
                      color: "#283d50",
                      textAlign: "justify",
                      margin: 0,
                    }}
                  >
                    {ceoData.message}
                  </p>
                </div>
                <div>
                  <h4
                    style={{
                      fontSize: "1.3rem",
                      fontWeight: "bold",
                      color: "#283d50",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {ceoData.name.toUpperCase()}
                  </h4>
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "#556877",
                      margin: 0,
                    }}
                  >
                    {ceoData.designation}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default CEOMessage;

